export const INDEX_START = 'INDEX_START';
export const INDEX_SUCCESS = 'INDEX_SUCCESS';
export const INDEX_FAILURE = 'INDEX_FAILURE';

export const FATAL_FAILURE = 'SYSTEM_FAILURE';
